<template lang="pug">
table.table.table-question
  thead
    tr
      th(v-for='c in columns' 
      :width="[c.type === 'action' ? '8%' : '' || c.type === 'name' ? '342px' : '' || c.type === 'status' ? '10%' : '' || c.key === 'stt' ? '5.5%' : '' || c.type === 'created_user' ? '8%' : '' || c.type === 'date' ? '13%' : '']"
      :key='c.title'
      :style="c.key === 'stt' ? 'padding-left: 0;' : ''"
    ) {{c.title}}
  tbody
    tr(v-if='this.inlineFilter === true' style="background: #EAEAEA 0% 0% no-repeat padding-box; opacity: 1;")
      td(v-for="c in columns"
        :width="[c.type === 'action' ? '8%' : '' || c.type === 'name' ? '342px' : '' || c.key === 'stt' ? '5%' : '']"
      )
        span(v-if="c.type === 'name'")
          input(@change="onnameChange($event)" placeholder="Tìm theo nội dung câu hỏi lớn" v-model="name"
          style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 10px; opacity: 1; padding: 5px;width:100%;")
    tr(v-if='this.data.length === 0', style='white-space: nowrap;') 
      td(:colspan="columns.length" style='padding: 16px 0px !important;')
        span Không tìm thấy dữ liệu
    tr(v-else v-for="(item, index) in data" :id="'row' + item.id")
      td(colspan='3' style="padding: 0 !important;")
        table.table-question2(width="100%")
          tr
            td(v-for='c in columns' 
              :width="[c.type === 'action' ? '8%' : '' || c.type === 'name' ? '342px' : '' || c.type === 'status' ? '10%' : '' || c.key === 'stt' ? '5.5%' : '' || c.type === 'created_user' ? '8%' : '' || c.type === 'date' ? '13%' : '']"
              :rowspan="[c.key === 'stt' ? '2' : '' || c.type === 'action' ? 2 : '']"
            )
              span(v-if='hasValue(item, c)' v-html='itemValue(item, c, index)' :class="c.type === 'name' ? 'td-col-name' : ''")
              span.list-action(v-if='isAction(c)')
                small(@click="editItem(item)")
                  img(:src="require('../../assets/images/faces/ic_edit.svg')")
              span.list-action(v-if='isAction(c)')
                small(@click="deleteItem(item)")
                  img(:src="require('../../assets/images/theory/delete-24px.svg')")
              .clearfix
              span.list-action(v-if='isAction(c)')
                small
                  .fas.fa-eye(style="color:#333333;margin-top: 9px;" @click="viewItem(item)")
          tr.filter-blue
            td(colspan="2" style="padding-bottom: 10px !important;")
              .filter-item
                span(:id="'categ_' + item.category_question.id" 
                  @click="filterItems(item.category_question.id, 1)"
                  :class="dataFilter.categories.includes(item.category_question.id) ? 'checked' : ''"
                ) {{item.category_question.name}}
                span(:id="'lv_' + item.level" 
                  @click="filterItems(item.level, 2)"
                  :class="dataFilter.level.includes(item.level) ? 'checked' : ''"
                ) {{getLevel(item.level)}}
                span(v-for="g in item.question_grade" 
                  :id="'grade_' + g.grade.id" 
                  @click="filterItems(g.grade.id, 3)"
                  :class="dataFilter.grades.includes(g.grade.id) ? 'checked' : ''"
                ) {{g.grade.name}}
    tr
      td(colspan='3' style="padding: 16px 0 0 !important;")
        Pagination(:currentPage='dataConfig.currentPage'
          :pageRange="dataConfig.pageRange"
          :itemsPerPage="dataConfig.itemsPerPage"
          :totalItems="dataConfig.totalItems"
          @pageChange="onPageChange")
</template>

<script>
import moment from 'moment'
import jQuery from 'jquery'
import Pagination from '../Front/Pagination'
export default {
  name: 'tbQuestion',
  components: {jQuery, Pagination},
  props: {
    columns: Array,
    data: Array,
    actions: Array,
    type: {
      type: String, // default | striped | hover
      default: ''
    },
    lstStatus: Array,
    lstLevel: Array,
    inlineFilter: {
      type: Boolean,
      default: false
    },
    lstFilter: Object,
    keyUpdate: Number,
    keyword: String,
    offset: Number,
    limit: Number,
    config: Object
  },
  data() {
    return {
      dataFilter: {
        categories: [...this.lstFilter.categories],
        level: [...this.lstFilter.level],
        grades: [...this.lstFilter.grades]
      },
      dataConfig: {
        currentPage: this.config.currentPage,
        pageRange: this.config.pageRange,
        totalItems: this.config.totalItems,
        itemsPerPage: this.config.itemsPerPage // limit
      },
      name: this.keyword
    }
  },
  methods: {
    filterItems(id, type) {
      if (type === 1) {
        if (!this.dataFilter.categories.includes(id)) {
          this.dataFilter.categories.push(id)
        } else {
          this.dataFilter.categories.splice(this.dataFilter.categories.indexOf(id), 1)
        }
      } else if (type === 2) {
        if (!this.dataFilter.level.includes(id)) {
          this.dataFilter.level.push(id)
        } else {
          this.dataFilter.level.splice(this.dataFilter.level.indexOf(id), 1)
        }
      } else if (type === 3) {
        if (!this.dataFilter.grades.includes(id)) {
          this.dataFilter.grades.push(id)
        } else {
          this.dataFilter.grades.splice(this.dataFilter.grades.indexOf(id), 1)
        }
      }
      this.$emit('onFilterBlue', this.dataFilter)
    },
    editItem(item) {
      // console.log('Edit Item ' + item.id)
      this.$emit('onItemEdit', item)
    },
    deleteItem(item) {
      // console.log('Delete Item ' + item.id)
      this.$emit('onItemDelete', item)
    },
    viewItem(item) {
      // console.log(item)
      this.$emit('onItemView', item)
    },
    hasValue(item, col) {
      if (col.type === 'action' || item[col.key] === 'undefined' || col.type === 'custom') {
        return false
      } else {
        return true
      }
    },
    fmDate(item, col) {
      return moment(item[col.key]).format('DD/MM/YYYY - HH:mm')
    },
    isAction(col) {
      if (col.type === 'action') return true
      else return false
    },
    isCustom(col) {
      if (col.type === 'custom') return true
      else return false
    },
    concatElement(value) {
      var cont = document.createElement('div')
      cont.innerHTML = value
      cont.getElementsByTagName('title')[0].remove()
      let x = cont.getElementsByTagName('span')[0]
      let y = cont.getElementsByTagName('p')[0]
      let el = document.createElement('p')
      el.innerHTML = x.innerText + ' ' + y.innerText
      y.replaceChild(el, y.childNodes[0])
      x.remove()
      return cont.innerHTML
    },
    itemValue(item, column, index) {
      var value = item[column.key]
      if (column.type) {
        if (column.type === 'date') {
          return this.fmDate(item, column)
        } else if (column.type === 'custom') {
          return value
        } else if (column.type === 'name') {
          // return this.concatElement(value)
          return value
        } else if (column.type === 'status') {
          for (let i = 0; i < this.lstStatus.length; i++) {
            if (this.lstStatus[i].key === value && value) {
              return '<div style="color:#3A9F00;">' + this.lstStatus[i].value + '</div>'
            } else if (this.lstStatus[i].key === value && !value) {
              return '<div style="color:#D63131;">' + this.lstStatus[i].value + '</div>'
            }
          }
        } else if (column.type === 'created_user' || column.type === 'updated_user') {
          return value.fullname
        }
      } else {
        if (typeof value === 'object') return value.name
        if (column.key === 'stt') return index + 1
        return value
      }
    },
    getLevel(level) {
      for (let i = 0; i < this.lstLevel.length; i++) {
        if (this.lstLevel[i].key === level) return this.lstLevel[i].value
      }
    },
    onnameChange(event) {
      // console.log(event.target.value)
      this.$emit('onfilterbyname', event.target.value)
    },
    onStatusChange(event) {
      let value = ''
      if (event.target.value === 'true') value = 1
      else if (event.target.value === 'false') value = 0
      else value = ''
      this.$emit('onfilterbystatus', value)
    },
    onPageChange(payload) {
      this.$emit('pageChange', payload)
    }
  }
}

</script>
<style lang="scss">
.list-action {
  small{width: 16px; height: 16px; display: inline-block;
    &:nth-child(2n + 1) {margin-right: 8px;}
    img{max-width: 100%; height: auto; cursor: pointer;}
    .fas {cursor: pointer;}
  }
}
.list-action-all {
    small {
      &:nth-child(2n) {margin-right: 0;}
  }
  small{width: 16px; height: 16px; margin-right: 10px; display: inline-block;
    .fas {cursor: pointer;}
    .fa-user-edit {color: #3A9F00;}
    .fa-user-lock {color: #D63131;}
  }
  
}
.table-question {
  margin-bottom: 0;
  thead {
    tr {
      th {
        padding: 10px 10px;
        text-align: left; 
        font: Bold 15px/18px Helvetica; 
        letter-spacing: 0px; 
        color: #343A40;
        opacity: 1;
      }
    }
  }
  tbody {
    .filter-blue {
      td {
        .filter-item {
          span {
            padding: 5px; 
            background: #F2F2F2; 
            border-radius: 10px; 
            color: #969FAD; 
            box-shadow: 0px 1px 3px #00000029; 
            margin: 0 8px 8px 0;
            cursor: pointer;
            display: inline-block;
            &.checked {
              background: #219AFF; 
              color: white;
            }
          }
        }
      }
    }
    .table-question2 {
      .td-col-name {
        max-height: 50px;
        display: block;
        overflow: hidden;
      }
    }
  }
  td {padding: 4px 8px !important;}
}
</style>



// WEBPACK FOOTER //
// tbQuestion.vue?4ff7b945